/**
 * @generated SignedSource<<0ea79766474a783293815dd8c658975f>>
 * @relayHash 9ae55f11de3546781ae0ddb7dbda32a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fd05f4a211f9d8f13c1d6344f6c906524d8efc4af876507ddfec555cc11ea09d

import type { ConcreteRequest } from 'relay-runtime';
export type graphqlHelpersFetchMediaTokenQuery$variables = {
  cloudId: string;
  contentId?: string | null;
  includeMediaItems?: boolean | null;
  missingContentId?: boolean | null;
  status?: ReadonlyArray<string | null> | null;
};
export type graphqlHelpersFetchMediaTokenQuery$data = {
  readonly content?: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly mediaItems?: ReadonlyArray<{
            readonly details: {
              readonly abuseClassification: {
                readonly classification: string | null;
                readonly confidence: string | null;
              } | null;
              readonly artifactsList: ReadonlyArray<{
                readonly createdAt: AGG$Long | null;
                readonly mimeType: string | null;
                readonly name: string;
                readonly processingStatus: string | null;
                readonly size: AGG$Long | null;
                readonly url: string | null;
              }> | null;
              readonly createdAt: AGG$Long | null;
              readonly failReason: string | null;
              readonly mediaMetadata: {
                readonly duration: number | null;
              } | null;
              readonly mediaType: string | null;
              readonly mimeType: string | null;
              readonly name: string | null;
              readonly preview: {
                readonly cdnUrl: string | null;
              } | null;
              readonly processingStatus: string | null;
              readonly representations: {
                readonly image: {
                  readonly _empty: boolean | null;
                } | null;
              } | null;
              readonly size: AGG$Long | null;
            };
            readonly id: string;
            readonly type: string;
          } | null> | null;
          readonly mediaToken: {
            readonly token: string | null;
          } | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
  readonly mediaConfiguration: {
    readonly clientId: string;
    readonly fileStoreUrl: string;
  } | null;
};
export type graphqlHelpersFetchMediaTokenQuery = {
  response: graphqlHelpersFetchMediaTokenQuery$data;
  variables: graphqlHelpersFetchMediaTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeMediaItems"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "missingContentId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "size"
},
v8 = {
  "kind": "ScalarField",
  "name": "mimeType"
},
v9 = {
  "kind": "ScalarField",
  "name": "processingStatus"
},
v10 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v11 = [
  {
    "condition": "missingContentId",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
          }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "concreteType": "ContentBodyPerRepresentation",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContentBody",
                    "kind": "LinkedField",
                    "name": "atlas_doc_format",
                    "plural": false,
                    "selections": [
                      {
                        "condition": "includeMediaItems",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                              }
                            ],
                            "concreteType": "MediaItem",
                            "kind": "LinkedField",
                            "name": "mediaItems",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "type"
                              },
                              {
                                "concreteType": "MediaFileDetails",
                                "kind": "LinkedField",
                                "name": "details",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "mediaType"
                                  },
                                  (v9/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "failReason"
                                  },
                                  (v10/*: any*/),
                                  {
                                    "concreteType": "MediaFilePreview",
                                    "kind": "LinkedField",
                                    "name": "preview",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "cdnUrl"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "MediaFileArtifact",
                                    "kind": "LinkedField",
                                    "name": "artifactsList",
                                    "plural": true,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v8/*: any*/),
                                      (v6/*: any*/),
                                      (v9/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "url"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "MediaFileRepresentations",
                                    "kind": "LinkedField",
                                    "name": "representations",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "MediaImageRepresentation",
                                        "kind": "LinkedField",
                                        "name": "image",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "_empty"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "MediaFileMetadata",
                                    "kind": "LinkedField",
                                    "name": "mediaMetadata",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "duration"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "MediaFileAbuseClassification",
                                    "kind": "LinkedField",
                                    "name": "abuseClassification",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "classification"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "confidence"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "EmbeddedMediaToken",
                        "kind": "LinkedField",
                        "name": "mediaToken",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "token"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "MediaConfiguration",
    "kind": "LinkedField",
    "name": "mediaConfiguration",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "clientId"
      },
      {
        "kind": "ScalarField",
        "name": "fileStoreUrl"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "graphqlHelpersFetchMediaTokenQuery",
    "selections": (v11/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "graphqlHelpersFetchMediaTokenQuery",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "9ae55f11de3546781ae0ddb7dbda32a5",
    "id": "fd05f4a211f9d8f13c1d6344f6c906524d8efc4af876507ddfec555cc11ea09d",
    "metadata": {},
    "name": "graphqlHelpersFetchMediaTokenQuery",
    "operationKind": "query",
    "text": "query graphqlHelpersFetchMediaTokenQuery($cloudId:ID!,$contentId:ID,$status:[String],$missingContentId:Boolean=false,$includeMediaItems:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaItems(cloudId:$cloudId)@include(if:$includeMediaItems){id,type,details{name,size,mimeType,mediaType,processingStatus,failReason,createdAt,preview{cdnUrl},artifactsList{createdAt,mimeType,name,processingStatus,size,url},representations{image{_empty}},mediaMetadata{duration},abuseClassification{classification,confidence}}},mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
  }
};
})();

(node as any).hash = "fad2f21d5b1421ab4639bbe3e5c6bb96";

export default node;
